import { createQRCode } from '../../Api'
import { DYNAMIC_LINK_CONFIG, PLL_IMAGES } from '../../Config/config'
export type DynamicLinkParams = {
  link: string
  shouldOpenAppStore?: boolean
  shouldOpenGooglePlay?: boolean
  socImg?: string
  socTitle?: string
  socDesc?: string
  tags?: string[]
  campaign?: string
  feature?: string
}

export const createBranchShortLink = async (linkParams: DynamicLinkParams) => {
  try {
    const branch = await import('branch-sdk')
    let data = {
      link: linkParams.link,
      campaign: linkParams?.campaign ?? '',
      channel: 'web',
      feature: linkParams?.campaign ?? '',
      $og_title: linkParams?.socTitle ?? DYNAMIC_LINK_CONFIG.shareTitle,
      $og_description: linkParams?.socDesc ?? '',
      $og_image_url: linkParams?.socImg ?? PLL_IMAGES.pllAppFeaturedImage,
    }
    if (branch) {
      branch.link(data, function (err, link) {})
    }
  } catch (err) {
    console.error('Error Creating Branch shortlink: ', err)
  }
}

export const createQRCodeFromLinkData = async (link: string) => {
  const qrCode = await createQRCode(link)
  if (!qrCode) {
    return null
  }
  return qrCode
}
